export default class LoginCtrl{
  constructor(AuthService){
    this.AuthService = AuthService;
    this.login = "";
    this.password = "";
    this.error = false;
    this.loginInProgress = false;
    // try to log me in first ....
    AuthService.autologin();
  }

  submit(){
    this.loginInProgress = true;
    this.AuthService.login(this.login, this.password).then(user =>{
      if(!user){
        this.loginInProgress = false;
        this.password = "";
        this.error = true;
      }
    })
  }


}


// WEBPACK FOOTER //
// ./src/Auth/LoginCtrl.js